/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard,
  faArrowLeft,
  faArrowsRotate,
  faBan,
  faCalendarDays,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faCircleInfo,
  faClose,
  faCloudUpload,
  faDownload,
  faEllipsis,
  faEnvelope,
  faEnvelopeCircleCheck,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faGlobe,
  faHouse,
  faImage,
  faInfoCircle,
  faKey,
  faList,
  faLocationDot,
  faLongArrowUp,
  faMinus,
  faNotdef,
  faPaperPlane,
  faPencil,
  faPhone,
  faPlus,
  faQuestionCircle,
  faRedo,
  faRightFromBracket,
  faSearch,
  faShield,
  faShieldAlt,
  faSignOutAlt,
  faSort,
  faTimesCircle,
  faTrashAlt,
  faTrashCan,
  faTriangleExclamation,
  faUser,
  faUserGroup,
  faUserShield,
  faUserSlash,
  faUsers,
  faUsersGear
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAddressCard,
  faHouse,
  faList,
  faCalendarDays,
  faArrowLeft,
  faArrowsRotate,
  faBan,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faCircleInfo,
  faClose,
  faCloudUpload,
  faDownload,
  faEllipsis,
  faEnvelope,
  faEnvelopeCircleCheck,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faGlobe,
  faImage,
  faInfoCircle,
  faKey,
  faLocationDot,
  faLongArrowUp,
  faMinus,
  faNotdef,
  faPaperPlane,
  faPencil,
  faPhone,
  faPlus,
  faQuestionCircle,
  faRedo,
  faRightFromBracket,
  faSearch,
  faShield,
  faShieldAlt,
  faSignOutAlt,
  faSort,
  faUserShield,
  faTimesCircle,
  faTrashAlt,
  faTrashCan,
  faTriangleExclamation,
  faUser,
  faUserGroup,
  faUserSlash,
  faUsers,
  faUsersGear
);
